import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import FormulaTextLabel from 'automation-ui-formula-editor/formula-editor/data-passing/FormulaTextLabel';
import { jsx as _jsx } from "react/jsx-runtime";
export default function WebhookActionExplainer({
  action
}) {
  const {
    method,
    url
  } = action.metadata;
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.webhook.explainer",
    options: {
      requestMethod: /*#__PURE__*/_jsx("strong", {
        children: method
      }),
      url: /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(UITruncateString, {
          children: /*#__PURE__*/_jsx(FormulaTextLabel, {
            text: url || ''
          })
        })
      })
    }
  });
}